export const deleteSubCompany = `mutation DeleteSubCompany($input: DeleteSubCompanyInput!) {
    deleteSubCompany(input: $input) {
      id
    }
  }
  `;
